export default function useCheckSignupProtocal() {
  // const checkSignupProtocal =
  //   window?.KALO_DATA?.reqCountry === "United States" || window?.KALO_DATA?.reqCountry === "United Kingdom";
  const checkSignupProtocal = window?.KALO_DATA?.reqCountry === "China";

  return { checkSignupProtocal };
}
